<!-- ------------------------------------------------------------------------->
<!-- ------------  The page changer used by Sample Search results  ----------->
<!-- ------------  and Protocol Search results                      ---------->
<!---------------------------------------------------------------------------->

<!--
<span style="background-color: hotpink;">currentPage:{{currentPage}}  totalCount:{{totalCount}}</span>
-->

<span *ngIf="totalCount>0" >
    {{buttons.length}}
    <!-- If more than one, add s for plural. -->
    page<span *ngIf="buttons.length > 1">s</span>&nbsp;

    <div class="btn-group" role="group" aria-label="...">

        <!-- Go to first page -->
        <label
            class="btn-nbia-pager btn-nbia-pager-left results-pager-font footer-colors unselectable pt-2"
            title="First"
            (click)="onGoFirstClickClick()"
        >
            <span class="unselectable">&lt;&lt;</span>
        </label>


        <!-- Go to previous page -->
        <label
            class="btn-nbia-pager results-pager-font footer-colors unselectable pt-2"
            title="Previous"
            (click)="onGoPreviousClick()"
        >
            <span>&lt;</span>
        </label>


        <!-- Go to a specific page -->
        <label
            *ngFor="let i of buttons"
            class="btn-nbia-pager  results-pager-font  unselectable pt-2"
            [ngClass]="{
                'selected': currentPage == i,
                'hide-button':( (i < buttonShowOffset) || (i - buttonShowOffset >=  maxButtonsToShow) )
            }"
            (click)="onClick( i )"
        >
            <span
                [ngClass]="{
                'button-number-hundreds': (i + 1) > 99,
                'button-number-tens': (i + 1) > 9  && (i + 1) < 100
            }"
            >
                {{i + 1}}
            </span>
        </label>


        <!-- Go to next page -->
        <label
            class="btn-nbia-pager results-pager-font footer-colors unselectable pt-2"
            title="Next"
            (click)="onGoNextClick()"
        >
            <span>&gt;</span>
        </label>


        <!-- Go to last page -->
        <label
            class="btn-nbia-pager btn-nbia-pager-right results-pager-font footer-colors unselectable pt-2"
            title="Last"
            (click)="onGoLastClick()"
        >
            <span>&gt;&gt;</span>
        </label>

    </div>
</span>
